(() => {
  const dialog=document.querySelector('#SSQuickView');if(!dialog)return;
  const content=dialog.querySelector('[data-quick-content]'),status=dialog.querySelector('[data-quick-status]'),retry=dialog.querySelector('[data-quick-retry]');
  let opener,url,request;
  async function open(href,trigger) {
    if(content.querySelector('songsong-product')?.adding)return;request?.abort();request=new AbortController();const signal=request.signal;
    opener=trigger;url=href;content.replaceChildren();status.textContent=dialog.dataset.loading;retry.hidden=true;
    if(!dialog.open)dialog.showModal();
    try {
      const target=new URL(href,location.origin);
      const preview=new URL(location.href).searchParams.get('preview_theme_id')||(window.Shopify?.designMode?window.Shopify?.theme?.id:null);
      if(preview)target.searchParams.set('preview_theme_id',preview);
      const response=await fetch(target,{signal});if(!response.ok)throw new Error('product');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const product=doc.querySelector('songsong-product');if(!product)throw new Error('Product template is missing');
      if(signal.aborted)return;
      // Reuse the same native product form, variant component and gallery as the product page.
      // Keep IDs unique even when the same product also has a form on the Home grid.
      const ids=new Map();product.querySelectorAll('[id]').forEach(el=>{ids.set(el.id,'Quick-'+el.id);el.id='Quick-'+el.id;});
      product.querySelectorAll('[for]').forEach(el=>{const id=el.getAttribute('for');if(ids.has(id))el.setAttribute('for',ids.get(id));});
      content.append(document.importNode(product,true));
      const description=doc.querySelector('.ss-at-description');
      if(description){description.className='ss-quick-description';content.querySelector('.ss-pdp-info').append(document.importNode(description,true));}
      status.textContent='';
    }catch(error){if(error.name!=='AbortError'){status.textContent=dialog.dataset.error;retry.hidden=false;}}
  }
  document.addEventListener('click',event=>{
    if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest('.ss-home .ss-gallery-card a[href], [data-cart-recommendations] .ss-gallery-card a[href]');
    if(!link)return;const target=new URL(link.href,location.origin);
    if(link.closest('.ss-home')&&!link.closest('[data-cart-recommendations]')&&document.querySelector('[data-home-quick-enabled]')?.dataset.homeQuickEnabled==='false')return;
    if(target.origin!==location.origin||!target.pathname.includes('/products/'))return;
    event.preventDefault();open(target.href,link);
  });
  document.addEventListener('submit',event=>{
    const card=event.target.closest('.ss-home .ss-gallery-card, [data-cart-recommendations] .ss-gallery-card');
    if(card?.closest('.ss-home')&&!card.closest('[data-cart-recommendations]')&&document.querySelector('[data-home-quick-enabled]')?.dataset.homeQuickEnabled==='false')return;
    if(card){event.preventDefault();const link=card.querySelector('a[href]');if(link)open(link.href,event.submitter||link);}
  });
  const close=()=>{if(content.querySelector('songsong-product')?.adding)return;request?.abort();dialog.close();content.replaceChildren();opener?.focus();};
  dialog.querySelector('[data-quick-close]').addEventListener('click',close);
  dialog.addEventListener('cancel',event=>{if(event.target!==dialog)return;event.preventDefault();close();});
  retry.addEventListener('click',()=>open(url,opener));
})();
